const actions = {
  CREATE_ILLUSTRATION: 'create_illustration',
  UPDATE_ILLUSTRATION: 'update_illustration',
  DELETE_ILLUSTRATION: 'delete_illustration',
  CREATE_REGION: 'create_region',
  CREATE_ICON: 'create_icon',
  UPDATE_ICON: 'update_icon',
  DELETE_ICON: 'delete_icon',
  CREATE_ANIMATED_ILLUSTRATION: 'create_animated_illustration',
  UPDATE_ANIMATED_ILLUSTRATION: 'update_animated_illustration',
  CREATE_ANIMATED_ICON: 'create_animated_icon',
  UPDATE_ANIMATED_ICON: 'update_animated_icon',
  CONFIGURE_BCS: 'configure_bcs',
  ADD_APP_ID: 'add_app_id',
  ASSIGN_DEVELOPER_PERMISSION: 'assign_developer_permission',
};

export default Object.freeze(actions);
export let actionsList = Object.values(actions);
